/* eslint-disable no-continue */

import { sity, plural, crutch, pluralCrutch } from './allText';

export default data => {
  const obj = {};
  const { url, locale, translate } = data.allData;
  const page = url.split('/').filter(Boolean);
  for (let a = 0, b = Object.keys(data), c = b.length; a < c; a += 1) {
    const str = data[b[a]];
    if (/allData/.test(b[a])) continue;
    if (/isNew/.test(b[a])) {
      obj[b[a]] = str;
      continue;
    }
    if (page[0] === 'zapchasti') {
      if (sity[str]) {
        obj[b[a]] = sity[str][locale].genitive;
        continue;
      }
      if (
        /transportTitle|transportDescriptions|transportHeader|transportNextDescriptions/.test(b[a])
      ) {
        if (plural[str]) {
          obj[b[a]] = plural[str][locale];
          continue;
        }
        if (data.section && str === 'легковые') {
          obj[b[a]] = ' ';
          continue;
        }
        obj[b[a]] = translate(str);
        continue;
      }
      obj[b[a]] = str;
      continue;
    }
    if (page[0] === 'avtosalony') {
      if (plural[str]) {
        obj[b[a]] = plural[str][locale];
        continue;
      }
      if (sity[str]) {
        if (b[a] === 'cityHeader') {
          obj[b[a]] = sity[str][locale].accusative;
        } else {
          obj[b[a]] = sity[str][locale].genitive;
        }

        continue;
      }
      if (
        /transportTitle|transportDescriptions|transportHeader|transportNextDescriptions/.test(b[a])
      ) {
        obj[b[a]] = translate(str);
        continue;
      }

      obj[b[a]] = str;
      continue;
    }
    if (page[0] === 'katalog-kompaniy') {
      if (sity[str] && b[a] === 'locationAccusative') {
        obj[b[a]] = sity[str][locale].accusative;
        continue;
      } else if (sity[str] && b[a] !== 'regLocation') {
        obj[b[a]] = sity[str][locale].genitive;
        continue;
      }
      if (
        /transportTitle|transportDescriptions|transportHeader|transportNextDescriptions/.test(b[a])
      ) {
        obj[b[a]] = translate(str);
        continue;
      }
      obj[b[a]] = translate(str);
      continue;
    }
    if (/commercial|pritsepy|avtobus|spetstehnika|gruzovye|vodnyi-transport/.test(page[0])) {
      if (sity[str]) {
        obj[b[a]] = sity[str][locale].genitive;
        continue;
      }
      const transport = crutch(data.isNew)[str];
      if (page[0] === 'commercial' && /transportTitle|transportHeader/.test(b[a])) {
        obj[b[a]] = translate('коммерческий транспорт');
        continue;
      } else if (page[0] === 'commercial' && /transportDescriptions/.test(b[a])) {
        obj[b[a]] = translate('коммерческого транспорта');
        continue;
      }
      if (/transportCategoryTitle/.test(b[a]) && transport && transport[locale].pluralTransport) {
        obj[b[a]] = transport[locale].pluralTransport;
        continue;
      }
      if (transport && transport[locale]) {
        obj[b[a]] = transport[locale][b[a]];
        continue;
      }
      if (pluralCrutch[str]) {
        obj[b[a]] = pluralCrutch[str][locale];
        continue;
      }
      if (
        /transportTitle|transportDescriptions|transportHeader|transportNextDescriptions/.test(b[a])
      ) {
        obj[b[a]] = translate(str);
        continue;
      }
    }
    if (page[0] === 'avto') {
      if (sity[str]) {
        obj[b[a]] = sity[str][locale].genitive;
        continue;
      }
      const transport = crutch(data.isNew)[str];
      if (transport && transport[locale]) {
        obj[b[a]] = transport[locale][b[a]];
        continue;
      }
      obj[b[a]] = translate(str);
      continue;
    }
    if (/moto|mototsikl|skuter|karting|kvadrotsikl|moped|baggi|tritsikl/.test(page[0])) {
      if (sity[str]) {
        obj[b[a]] = sity[str][locale].genitive;
        continue;
      }
      const transport = crutch(data.isNew)[str];
      if (transport && transport[locale]) {
        obj[b[a]] = transport[locale][b[a]];
        continue;
      }
      obj[b[a]] = translate(str);
      continue;
    }
    obj[b[a]] = str;
  }

  return obj;
};



// WEBPACK FOOTER //
// ./src/shared/modules/subjectiveText/index.js